export default "__VITE_ASSET__DkM7Anoa__"